import React from "react";

import { POSAPricesI } from "../../../model/POSAPricesI";

export const POSAPricesSelect = ({
  prices,
  priceKey,
  handlePrice,
  id
}: POSAPricesI) => {
  if (!prices) return null;
  return (
    <div>
      <select
        id={id}
        className="form-control"
        value={priceKey}
        onChange={handlePrice}
      >
        <option>0</option>
        {Object.keys(prices).map((key) => (
          <option key={key}>{key}</option>
        ))}
      </select>
    </div>
  );
};
